import { createSlice } from '@reduxjs/toolkit';
import invariant from 'invariant';
import appTypes from '../app/types';
import { getContactMapKey } from './mappers';
const initialState = {};
const mergeUniqueStrings = (existing, incoming) => {
    const result = [...(existing || [])];
    (incoming || []).forEach(id => {
        if (id && !result.includes(id)) {
            result.push(id);
        }
    });
    return result;
};
const upsertIntoState = (state, contacts) => {
    contacts.forEach(contact => {
        var _a, _b;
        const key = getContactMapKey(contact);
        if (key) {
            const existing = state[key];
            // sequenceNum is Redux-owned; MST hydrators always send 0 and must not clobber it
            // savedDatapoints is append-only (same as MST); mid-hydrate syncs must not wipe ids
            state[key] = Object.assign(Object.assign({}, contact), { sequenceNum: (_b = (_a = existing === null || existing === void 0 ? void 0 : existing.sequenceNum) !== null && _a !== void 0 ? _a : contact.sequenceNum) !== null && _b !== void 0 ? _b : 0, savedDatapoints: mergeUniqueStrings(existing === null || existing === void 0 ? void 0 : existing.savedDatapoints, contact.savedDatapoints), companyName: contact.companyName || (existing === null || existing === void 0 ? void 0 : existing.companyName) || '' });
        }
    });
};
const slice = createSlice({
    name: 'CONTACTS',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
    },
    reducers: {
        setContact(state, { payload }) {
            upsertIntoState(state, [payload]);
        },
        setContacts(state, { payload }) {
            upsertIntoState(state, payload);
        },
        updateContact(state, { payload }) {
            const existing = state[payload.key];
            if (existing) {
                state[payload.key] = Object.assign(Object.assign({}, existing), payload.changes);
            }
        },
        spawnContact(state, { payload }) {
            // action designed to fix references for wishlist contact. In moment when contact is saved as partial contact
            const contact = state[payload];
            invariant(contact, 'duplicateContact(): invalid id provided');
            if (contact.contactId) {
                state[contact.contactId] = contact;
            }
        },
        removeContact(state, { payload }) {
            delete state[payload];
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
